import { Component } from '@angular/core';

@Component({
    selector: 'app-breadcrumb-company-user-profile-detail',
    templateUrl: './breadcrumb.company.user.profile.detail.component.html'
})

export class BreadcrumbCompanyUserProfileDetailComponent { }
